export const SET_LOGGED_IN = 'SET_LOGGED_IN'
export const SET_NAME = 'SET_NAME'
export const SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS'

export default {
  [SET_LOGGED_IN] (state, isLogged) {
    state.isLoggedIn = isLogged
  },
  [SET_NAME] (state, name) {
    state.userName = name
  },
  [SET_MESSAGE_STATUS] (state, payload) {
    state.UserMessageStatus = payload.msg
    state.UserSnackbarColor = payload.color
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/UserMutations.js